// extracted by mini-css-extract-plugin
export default {"fiberCell":"ecb7ALGFhpm4NqvIQu6J","value":"Y7HAdXESJvApxyfTNjpH","description":"NY1Zwuri4Ftf7gp2yepU"};